import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_trailer__AV]: 'Trailer'
}
